import { $http } from "@/plugins/api";
import { useFlag } from "@/composables/useFlags/useFlag";
import type { Commit } from "vuex";
import type { Params } from "@/types/api";

interface MailHistoryState {
  totalEmailsAnalyzed: number;
  totalIncidents: number;
}

const { isFeatureAvailable: isIncidentsV3Available } = useFlag("INCIDENTS_V3");

const mailHistory = (): MailHistoryState => {
  return {
    totalEmailsAnalyzed: 0,
    totalIncidents: 0,
  };
};
const state = mailHistory();

const getters = {
  totalEmailsAnalyzed: (state: MailHistoryState) => state.totalEmailsAnalyzed,
  totalIncidents: (state: MailHistoryState) => state.totalIncidents,
};

const actions = {
  async getTotalEmailsAnalyzed(
    { commit }: { commit: Commit },
    { organisationId, params }: { organisationId: string; params: Params },
  ) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get<{ count: number }>(
        `${import.meta.env.VITE_API_CLIENT_V3}/history/${organisationId}/messages/count?${filterParams.toString()}`,
      );
      commit("setTotalEmailsAnalyzed", res.data.count);
    } else {
      const res = await $http.get<{ Count: number }>(
        `${import.meta.env.VITE_API_CLIENT}/v1/pt/history/platform/PhishTitan/type/General/globalOrganisationID/${organisationId}/count?${filterParams.toString()}`,
      );
      commit("setTotalEmailsAnalyzed", res.data.Count);
    }
  },

  async getTotalIncidents(
    { commit }: { commit: Commit },
    { organisationId, params }: { organisationId: string; params: Params },
  ) {
    const filterParams = new URLSearchParams(params);

    if (isIncidentsV3Available.value) {
      const res = await $http.get<{ count: number }>(
        `${import.meta.env.VITE_API_CLIENT_V3}/history/${organisationId}/incidents/count?${filterParams.toString()}`,
      );
      commit("setTotalIncidents", res.data.count);
    } else {
      const res = await $http.get<{ Count: number }>(
        `${import.meta.env.VITE_API_CLIENT}/v1/pt/history/platform/PhishTitan/type/Classified/globalOrganisationID/${organisationId}/count?${filterParams.toString()}`,
      );
      commit("setTotalIncidents", res.data.Count);
    }
  },
};

const mutations = {
  setTotalEmailsAnalyzed: (state: MailHistoryState, count: number) => {
    state.totalEmailsAnalyzed = count;
  },
  setTotalIncidents: (state: MailHistoryState, count: number) => {
    state.totalIncidents = count;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
